import React from 'react'
import './ReactionBanner.css'

const ReactionBanner = ({ text, animationType }) => {
  const getAnimationClass = () => {
    switch (animationType) {
      case 'speed':
        return 'speed-animation'
      case 'combo':
        return 'combo-animation'
      case 'fire':
        return 'fire-animation'
      case 'wrong':
        return 'wrong-animation'
      case 'final':
        return 'final-animation'
      default:
        return 'default-animation'
    }
  }

  return (
    <div className={`reaction-banner ${getAnimationClass()}`}>
      {text}
    </div>
  )
}

export default ReactionBanner